export const isPdf = (attachment) => {
  if (!attachment) return false;

  // Check fileExtension field
  if (attachment.fileExtension && attachment.fileExtension.toLowerCase().includes('pdf')) {
    return true;
  }

  // Check URL
  if (attachment.url && attachment.url.toLowerCase().includes('.pdf')) {
    return true;
  }

  // Check fileName
  if (attachment.fileName && attachment.fileName.toLowerCase().endsWith('.pdf')) {
    return true;
  }

  return false;
};

export const isImage = (attachment) => {
  if (!attachment) return false;

  // Check fileExtension field
  if (attachment.fileExtension && attachment.fileExtension.toLowerCase().includes('image')) {
    return true;
  }

  return !isPdf(attachment);
};
